/**
 * Image optimization utilities for Next.js Image component
 */

export function generateBlurDataURL(imageId: string | null | undefined): string {
  // Return a minimal blur placeholder if no image
  if (!imageId) {
    return 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k='
  }
  
  // For Directus images, create a low-quality version for blur placeholder
  const baseUrl = process.env.NEXT_PUBLIC_DIRECTUS_URL?.replace('/api', '') || ''
  
  // If it's already a full URL, extract the ID
  if (typeof imageId === 'string' && imageId.startsWith('http')) {
    const matches = imageId.match(/\/assets\/([^?]+)/)
    if (matches) {
      imageId = matches[1]
    }
  }
  
  // Return a very low quality, small version for blur effect
  return `${baseUrl}/assets/${imageId}?width=10&height=10&quality=10&format=webp`
}

export function getOptimizedImageSizes(context: 'hero' | 'card' | 'thumbnail' | 'content' | 'featured'): string {
  const sizeMap = {
    hero: "(max-width: 768px) 100vw, 896px",
    card: "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 400px", 
    thumbnail: "(max-width: 768px) 25vw, (max-width: 1200px) 20vw, 150px",
    content: "(max-width: 768px) 100vw, (max-width: 1200px) 70vw, 800px",
    featured: "(max-width: 768px) 100vw, (max-width: 1200px) 90vw, 1200px"
  }
  return sizeMap[context]
}

export function getImageDimensions(context: 'hero' | 'card' | 'thumbnail' | 'content' | 'featured'): { width: number; height: number } {
  const dimensionMap = {
    hero: { width: 1200, height: 600 },
    card: { width: 400, height: 225 },
    thumbnail: { width: 150, height: 150 },
    content: { width: 800, height: 450 },
    featured: { width: 1200, height: 630 }
  }
  return dimensionMap[context]
}

/**
 * Optimized image loader for Directus images
 */
export function directusImageLoader({ src, width, quality }: { src: string; width: number; quality?: number }) {
  // If it's already optimized or a placeholder, return as-is
  if (src.startsWith('data:') || src.includes('placeholder')) {
    return src
  }
  
  // Add optimization parameters
  const url = new URL(src)
  url.searchParams.set('width', width.toString())
  url.searchParams.set('quality', (quality || 75).toString())
  url.searchParams.set('format', 'webp')
  
  return url.toString()
}
